import { Typography, Stack } from '@mui/material';

import { OverflowTooltip } from '../tooltips/overflowTooltip';

export const ResourceIdentifierItem = ({
  providerId,
  name,
}: {
  providerId: string;
  name: string;
}) => {
  return (
    <Stack gap='4px' width='100%' className='truncate'>
      <OverflowTooltip
        shouldCloseOnScroll={true}
        text={providerId}
        renderContent={(text, ref) => (
          <Typography variant='subtitle1' className='truncate' ref={ref}>
            {text}
          </Typography>
        )}
      />
      <Typography variant='body2' className='truncate'>
        {name}
      </Typography>
    </Stack>
  );
};
